import React from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import { JobRole } from "../constants";
import { checkAuthToken, removeAuthUserInfo } from "../helpers";
import LocalstorageService from "../helpers/localstorage-service";
import { userLogout } from "../store/slices/Auth/authSlice";

const RouteAuthGuard = ({
  isAuthProtected,
  isLockScreen,
  allowedRoles,
  unauthorizedRedirect = "/dashboard",
  children,
}) => {
  const token = checkAuthToken();
  const dispatch = useDispatch();

  if (!isAuthProtected && token) {
    return <Navigate to="/dashboard" replace />;
  } else if (isAuthProtected && !token) {
    removeAuthUserInfo();
    dispatch(userLogout());
    return <Navigate to="/login" replace />;
  } else if (isAuthProtected && token && isLockScreen) {
    return <Navigate to="/lock-screen" replace />;
  } else if (isAuthProtected && token && allowedRoles !== undefined) {
    const storedRole = LocalstorageService.getItem(JobRole);
    const roleId = storedRole === null ? Number.NaN : Number(storedRole);
    const hasAllowedRole =
      Number.isInteger(roleId) &&
      Array.isArray(allowedRoles) &&
      allowedRoles.some((allowedRole) => Number(allowedRole) === roleId);

    if (!hasAllowedRole) {
      return <Navigate to={unauthorizedRedirect} replace />;
    }
  }

  return children;
};

export default RouteAuthGuard;
